import { ManualNotificationType } from "@avenueops/shared-types";
import IntlPhoneNumberInput from "components/inputs/IntlPhoneNumberInput";
import CustomSubscriberSignalFormat from "components/monitors/editFormReboot/CustomSubscriberSignalFormat";
import { useFormContext, useWatch } from "react-hook-form";

interface Props {
  disableCustomize?: boolean;
  notificationPrefix: string;
}

export function WhatsAppNotificationInput({ disableCustomize, notificationPrefix }: Props) {
  const {
    formState: { errors },
    control,
    watch,
  } = useFormContext();
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });
  const useCustomIntegration = watch(`${notificationPrefix}.useCustomIntegration`);

  return (
    <>
      <div className="col-span-4">
        <IntlPhoneNumberInput
          errors={errors}
          title="WhatsApp Number to Notify"
          defaultValue={notification.recipientValue ?? ""}
          fieldName={`${notificationPrefix}.recipientValue`}
        />
      </div>
      {disableCustomize ? null : (
        <div className="col-span-6">
          <CustomSubscriberSignalFormat
            control={control}
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            includeTitle={true}
          />
        </div>
      )}
    </>
  );
}
